import React from 'react';

export const Logo = ({ className = "w-10 h-10", showText = true, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <img 
        src="/logo.png" 
        alt="Viral Clipes" 
        className={className}
      />
      {showText && (
        <span className={`font-heading font-bold ${textClassName || "text-lg sm:text-xl"}`}>
          Viral Clipes
        </span>
      )}
    </div>
  );
};

export default Logo;
